module.exports = __webpack_public_path__ + "img/prod-3.742af7a7.jpg";